import React from 'react';
import InputNumber from '../../../../../../../shared/design-system/components/input-number';

type IProps = {
  value: string;
  placeholder?: string;
  onUpdateFilterConditionValue: (value: number) => void;
  disabled?: boolean;
};

const ProspectFiltersNumberInput: React.FC<IProps> = ({
  value,
  placeholder = 'Enter number',
  onUpdateFilterConditionValue,
  disabled = false,
}) => (
  <InputNumber
    type="number"
    placeholder={placeholder}
    value={value || ''}
    onChange={(num: string) => {
      onUpdateFilterConditionValue(Number(num));
    }}
    disabled={disabled}
  />
);

export default ProspectFiltersNumberInput;
